// extracted by mini-css-extract-plugin
export var animating = "_2g-3";
export var background = "_2g-6";
export var constrainHeight = "_2g-2";
export var dark = "_2g-4";
export var dropdown = "_2g-1";
export var leave = "_2g-5";
export var option = "_2g-7";
export var root = "_2g-0";